var _this = this;
// Our events object.
// This keeps tracks of key (function name) and value (callback functions) pairs.
var events = {};
// @public - Listeners
// Here we will register events, multiple events can registered for the same event.
var on = function (type, handler) {
    if (!handler) {
        throw new ReferenceError('handler not defined.');
    }
    if (!events[type]) {
        events[type] = [];
    }
    // Statistics is reserved once for the widgets
    // mensenlinq-event is reserved for the customer to tap into
    if ((type === 'statistics' || type === 'mensenlinq-event') &&
        events[type].length > 0) {
        return _this;
    }
    else {
        events[type].push(handler);
    }
    return _this;
};
// @public - Publishers
// Here we can emit events, such as a section of value has changed.
var emit = function (type) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    if (events[type]) {
        var handlers = events[type];
        for (var _a = 0, handlers_1 = handlers; _a < handlers_1.length; _a++) {
            var handler = handlers_1[_a];
            handler.apply(_this, args);
        }
    }
};
var eventsSystem = function () {
    return {
        on: on,
        emit: emit,
    };
};
eventsSystem.init = function () {
    // Assign the logic to the window, so we can communicate page-wide.
    window._mensenlinqEvents = window._mensenlinqEvents || {
        on: on,
        emit: emit,
    };
};
export default eventsSystem;
